<script>
import ChallengeForm from './ChallengeForm'

export default {
  components: {
    ChallengeForm
  },

  props: {
    id: {
      required: true
    }
  },

  data() {
    return {
      challenge: null
    }
  },

  created() {
    this.Loading.yes = true

    this.axios.get('/challenges/' + this.id)
      .then(response => (this.challenge = response.data))
      .then(() => (this.Loading.yes = false))
  }
}
</script>

<template>
  <section class="hero is-primary">
    <div
      class="container"
      v-if="challenge">
      <h1 class="title is-2">Editer le challenge</h1>

      <challenge-form
        :challenge="challenge"/>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 640px;
}

.hero {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageChallengeEdit.vue